<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>推送开启奖励</span>
      </div>
      <el-form :inline="true">
        <reward :value="formData" :drawer="true" />
        <el-form-item style="margin-top: 10px;">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Reward from '@/components/Reward/index.vue'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'PushReward',
  components: { Reward },
  data() {
    return {
      key: 'OpenPushReward',
      formData: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateCommonCfg({ name: this.key, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
